const DeliveriesModal = () => {
    return (
        <div className="modal fade" id="deliveriesModal" tabIndex="-1" aria-labelledby="deliveriesModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="deliveriesModalLabel">Package Delivery Address</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="delivery-address">
                            <h6>Package Delivery Address:</h6>
                            <p className="mb-0">
                                145 Great Road STE 6<br />
                                Farm Hill Plaza # 1011<br />
                                Acton, MA 01720
                            </p>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeliveriesModal;
